/**
 *
 * /EditInPlace
 *
 */

import React, { useState, useEffect, useRef } from 'react'

// NPM Libraries
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Components
import MutationStatusIndicator from 'components/MutationStatusIndicator'
import OnClickOutside from 'components/OnClickOutside'

const EditInPlaceStyles = styled('div')`
	.eip-row {
		display: flex;
		justify-content: space-between;
		max-width: 320px;
	}
	.detail-icon {
		line-height: inherit;
	}
	.detail-input {
		background: #eaeef5;
		border-radius: 4px;
		border: 0;
		padding: 2px 5px 2px 5px;
		margin-left: -5px;
		font-size: 0.95em;
		width: 90%;
		margin-bottom: 1px;
	}
	.detail-display {
		color: inherit;
	}
`

function EditInPlace({
	display_jsx,
	initial_value,
	default_text,
	onSubmit,
	format,
	initial_value_2,
	default_text_2,
	loading,
	mutation_status,
	children,
	...input_props
}) {
	// input_props can include required, type, etc.

	const [editing, setEditing] = useState(false)
	const [value_state, setValue] = useState(initial_value)
	const [value_state_2, setValue2] = useState(initial_value_2)
	const inputRef = useRef(null)

	if (mutation_status) {
		loading = mutation_status.loading
	} else {
		mutation_status = { loading }
	}

	useEffect(() => {
		if (editing) {
			inputRef.current.focus()
		}
	}, [editing])

	useEffect(() => {
		if (!loading) {
			setValue(initial_value)
			setValue2(initial_value_2)
		}
	}, [loading])

	if (!editing)
		return (
			<EditInPlaceStyles>
				<div className="eip-row">
					<span
						className="detail-display"
						style={{
							opacity: loading || !value_state ? '0.5' : '1',
						}}
						onClick={() => {
							if (!initial_value && !loading) {
								setEditing(true)
							}
						}}
						role="presentation"
					>
						{display_jsx || value_state || default_text}
					</span>
					{default_text_2 && (
						<span
							className="detail-display"
							style={{
								color: !initial_value_2 ? '#ccc' : 'inherit',
								opacity: loading || !value_state_2 ? '0.5' : '1',
							}}
						>
							{value_state_2 || default_text_2}
						</span>
					)}
					<span className="detail-icon">
						<MutationStatusIndicator {...mutation_status} />
					</span>
					{!mutation_status.loading && (
						<span>
							<button
								type="button"
								className="btn-unstyled detail-icon clickable text-muted ml-2 pencil-button"
								style={{ fontSize: '0.8em' }}
							>
								<FontAwesomeIcon
									icon={initial_value ? 'pen' : 'plus'}
									onClick={() => setEditing(true)}
								/>
							</button>
							{children}
						</span>
					)}
				</div>
			</EditInPlaceStyles>
		)

	if (editing)
		return (
			<OnClickOutside handleClickOutside={() => setEditing(false)}>
				<EditInPlaceStyles>
					<form
						onSubmit={(e) => {
							e.preventDefault()
							onSubmit(value_state, value_state_2)
							setEditing(false)
							return false
						}}
						className="eip-row"
					>
						<input
							value={value_state || ''}
							onChange={(e) => {
								const value = format ? format(e.target.value) : e.target.value
								setValue(value)
							}}
							className="detail-input"
							{...input_props}
							autoFocus
							ref={inputRef}
							placeholder={default_text}
						/>
						{default_text_2 && (
							<input
								value={value_state_2 || ''}
								onChange={(e) => {
									const value = format ? format(e.target.value) : e.target.value
									setValue2(value)
								}}
								className="detail-input"
								{...input_props}
								placeholder={default_text_2}
							/>
						)}
						<button type="submit" className="btn-unstyled detail-icon ml-2">
							<FontAwesomeIcon icon="check" className="text-success" />
						</button>
					</form>
				</EditInPlaceStyles>
			</OnClickOutside>
		)
}

EditInPlace.propTypes = {}

export default EditInPlace
